<div *ngIf="exibirCarrinho">
  <div class="row carrinho {{tema}}"
       (click)="abraTelaCarrinho()" [ngClass]="{'deslocado': exibindoMenu, 'poweredby': exibirPoweredBy}">
    <div class="col flex-fixed-width-item pr-0">
      <span class="qtde_itens">{{pedido.qtde}}</span>
      <i class="fe-shopping-cart font-15"></i>
    </div>
    <div class="col ml-0 mr-0 text-center">
    <span>
    {{naRodada ? 'Ver rodada' : 'Ver Carrinho'}}
    </span>
    </div>
    <!-- na rodada do rodízio a barra não mostra valor: o cliente vê os valores só ao abrir a rodada ou a conta -->
    <div class="col-auto text-right mr-2" *ngIf="!naRodada">
    <span class="font-13">
      {{ pedido.total | currency: 'BRL'}}
    </span>
    </div>
    <!-- espaçador do mesmo tamanho da coluna do ícone, para o texto ficar centralizado na barra -->
    <div class="col flex-fixed-width-item" *ngIf="naRodada"></div>
  </div>
</div>



